import { lazy, Suspense, type ReactNode } from 'react';
import type { JsonEditorProps } from './types';

const JsonEditor = lazy(() => import('./JsonEditor'));

type Props = JsonEditorProps & {
    readonly fallback?: ReactNode;
};

const JsonEditorLazy = ({ fallback, ...restProps }: Props) => (
    <Suspense
        fallback={fallback ?? (
            <div>Loading...</div>
        )}
    >
        <JsonEditor
            {...restProps}
        />
    </Suspense>
);

export default JsonEditorLazy;
